import React, { useRef, useState, useContext } from 'react'


import style from '../../../styles/mystyle.module.css'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { constants } from "../../../constants";
import { useCart } from "../../../context/cart/use-cart";
import { useRouter } from 'next/router'
import axios from 'axios'
import * as config from "../../../next.config.js";
import Diet from './Diet'
import { getCookieValue } from '../../helpers/helpers'
import TermsContext from "../../../context/Trems"
import Loading from "../../../components/components/Loaders/Loading";
import { getImage } from '../../helpers/images'
import LoadingButton from "@mui/lab/LoadingButton"
import { styled } from '@mui/system'
import ConfirmDialog from "../Dialogs/ConfirmDialog";
import IconButton from "@mui/material/IconButton";
const Customebtn2 = styled(LoadingButton)({
    padding:" 5px 10px !important", 
    color:"white",
    backgroundColor:"#02AAB0",
    border:"none",
    borderRadius: "10px",
    width: "40%",
    height: "auto",
    fontSize:"1rem",
    zindex:1,
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    marginLeft:"auto",
    marginRight:"auto",
    textTransform:"capitalize",

  
    '&.Mui-disabled': {   
      color: "grey !important",
      border: "none !important",
      backgroundColor: "#bcbcbc70 !important",
  
    },
    '&:hover':{  
      border:"none"
    },
  '@media (min-width:100px) and (max-width:768px)': {
  padding:" 5px 10px !important", 
  color:"white !important ",
  backgroundColor:" #02AAB0 !important",
  fontSize:"0.9rem !important",
  width:"129px !important  ",
  border:"none !important",
  borderRadius:'10px !important',
  height: "auto",
  display:"flex !important",
  zindex:1,
  alignItems:"center !important",
  justifyContent:"center !important",
  marginLeft:"auto !important",
  marginRight:"auto !important",
    },
  
  '@media (min-width:768px) and (max-width:912px)': {
  padding:" 5px 10px !important", 
  color:"white !important ",
  backgroundColor:" #02AAB0 !important",
  fontSize:"1rem !important",
  width:"200px !important  ",
  border:"none !important",
  borderRadius:'10px !important',
  height: "auto",
  display:"flex !important",
  zindex:1,
  alignItems:"center !important",
  justifyContent:"center !important",
  marginLeft:"auto !important",
  marginRight:"auto !important",
  },
  '@media (min-width:913px) ': {
  padding:" 5px 10px !important", 
  color:"white !important ",
  backgroundColor:" #02AAB0 !important",
  fontSize:"1.2rem !important",
  width:"158px !important  ",
  border:"none !important",
  borderRadius:'10px !important',
  height: "auto",
  display:"flex !important",
  zindex:"1 !important" ,
  alignItems:"center !important",
  justifyContent:"center !important",
//   marginLeft:"auto !important",
//   marginRight:"auto !important",

  
  
  
  },
   
  });
function MedicalCard(props) {
  const { items, clearCart } = useCart();
  const vocabTerms = useContext(TermsContext)
  const { t } = useTranslation("common")
  const [showloading, setShowloading] = useState(true);
  const [NotFound, setNotFound] = useState(false);
  const [entityDetails, setentityDetails] = useState([]);
  const router = useRouter()


  const types = ["products", "medical", "diet"]
  React.useEffect(() => {


    if (items && items.length > 0) {
      setNotFound(false);
      let entities;
      entities = items.filter(i => i.productUnitPrice != null && types.includes(i.type) && i.userCountry == getCookieValue("userCountry"));
      if (entities != undefined && entities.length > 0) {
        let entityIds2 = entities.map(ele => ele.entityDetailsId);
        if (entityIds2.length > 0) {
          let StatusIds = vocabTerms.statusIds;

          let SearchData = {
            statusId: JSON.stringify(StatusIds),
            lang: router.locale,
            // active: 1, 
            entityId: JSON.stringify(entityIds2)
          };

          if (getCookieValue("userCountry")) {
            SearchData.userCountryCode = getCookieValue("userCountry")
          }

          setShowloading(true);
          axios.post(`${config["basePath"]}/api/registeration/entityDetails/get`, {
            data: SearchData,
            headers: {
              "Content-Type": "application/json",
              "accept-language": router.locale
            }
          }).then(async respEntityDetails => {
            setShowloading(false);
        
            let tmpRresponse = respEntityDetails.data.data.data;
            if (tmpRresponse.length > 0) {
              tmpRresponse.map(i => {
                let Couunter = 0
                if (
                  items.filter(
                    x => x.userCountry == getCookieValue("userCountry") && x.entityDetailsId == i.id).length > 0) {
                  items.filter(
                    x => x.userCountry == getCookieValue("userCountry") && x.entityDetailsId == i.id).map(a => {

                      Couunter += a.quantity
                    })
                  i.Counter = Couunter
                  return i

                }

              });
              await axios.get(`${config["basePath"]}/api/registeration/addressDetails/get`,
                {
                  params: {
                    entityId: JSON.stringify(tmpRresponse.map(i => i.id)),
                    statusId: JSON.stringify(StatusIds),
                    lang: router.locale
                  },
                  headers: {
                    "Content-Type": "application/json",
                    "accept-language": router.locale
                  }
                }
              ).then(respAddressDetails => {
                if (respAddressDetails.data.data.content.length > 0) {
                  tmpRresponse.map(i => {
                    i.addressDetails = respAddressDetails.data.data.content.filter(
                      x => x.entityDetailsId == i.id
                    );
                    return i;
                  });
                }
              }).catch(err => (err));
              let ImageType = ["logo"];
              await axios.get(`${config["basePath"]}/api/registeration/entityImages/get`,
                {
                  params: {
                    entityId: JSON.stringify(tmpRresponse.map(i => i.id)),
                    statusId: JSON.stringify(StatusIds),
                    entityImageType: JSON.stringify(ImageType),
                    limit: constants.limitOfEntityImages
                  },
                  headers: {
                    "Content-Type": "application/json",
                    "accept-language": router.locale
                  }
                }
              ).then(respEntityImages => {
                if (respEntityImages.data.data.data.length > 0) {

                  tmpRresponse.map(i => {
                    i.images = respEntityImages.data.data.data.filter(
                      x => x.entityDetailsId == i.id
                    );
                    return i;
                  });
                }
                tmpRresponse.map(ele => {
                  ele.images.map(d => {
                    if (d.files) {
                      getImage(d.files.fileId, d.files.filePath).then(res => {
                        d.image = res
                      })


                    }
                  })
                })
              }).catch(err => (err));

              await axios.get(`${config["basePath"]}/api/registeration/workTime/get`, {
                params: {
                  entityId: JSON.stringify(tmpRresponse.map(i => i.id)),
                  statusId: JSON.stringify(StatusIds),
                  limit: constants.limitOfWorkingTime
                },
                headers: {
                  "Content-Type": "application/json",
                  "accept-language": router.locale
                }
              }).then(respWorkTime => {
                if (respWorkTime.data.data.data.length > 0) {
                  tmpRresponse.map(i => {
                    i.workTime = respWorkTime.data.data.data.filter(
                      x => x.id == i.id
                    );
                    return i;
                  });
                }
              }).catch(err => (err));
              setShowloading(false);
              setentityDetails([...tmpRresponse]);
            }
          })
        
          setNotFound(false);
        }
        else if (entities.length == 0) {
          setNotFound(true);
          setShowloading(false);
        }

      }
      else {
        setNotFound(true);
        setShowloading(false);
      }
    }
    else {
      if (items && items.length == 0) {
        setNotFound(true);
      }
      setShowloading(false);
    }
  }, [router.query, items])
  const [showDeleteDialoge, setShowDeleteDialog] = useState({
    show: false,
    message: "",
    type: "success"
  });
  return (
    <div >
      <ConfirmDialog
        open={showDeleteDialoge.show}
        text={showDeleteDialoge.message}
        type={showDeleteDialoge.type}
        title={t("ttlMessage")}
        confirmBtnTitle={t("btnDelete")}
        btnCancel={() => {
          showDeleteDialoge.show = false;

          setShowDeleteDialog({ ...showDeleteDialoge });
        }}
        btnOk={() => {
          showDeleteDialoge.show = false;
          // removeItem(ele)
          clearCart();
          setShowDeleteDialog({ ...showDeleteDialoge });
          setentityDetails([]);
        }}
      />
      <div className={style.SectionContainer} >
        <div className={style.allcard}>

          <div className={style.paddingRatingDiv}></div>
          <div className={style.HeaderBasket} >
            <div><img className={style.icontitle} src={`${config.basePath}/assest/basket.svg`} /></div>
            <div className={style.textaboutdoctor1 + " " + style.Blod}  >{t("Basket")}</div>
          
          <div>{NotFound == false ? (
            <IconButton
              onClick={() => {
                showDeleteDialoge.show = true;
                showDeleteDialoge.message = t("msgDeleteOrderPackage");
                showDeleteDialoge.type = "success";
                setShowDeleteDialog({ ...showDeleteDialoge });
              }}
            >
              <img
                src={`${config.basePath}/assest/delete.svg`}
                className={style.iconremoveBasket}
              />
            </IconButton>
          ) : (
              ""
            )}
            </div>
            </div>
          <div style={{ textAlign: "center",display:"flex",justifyContent:"center"  }}>
            {" "}
            {showloading ? <Loading /> : ""}
          </div>
          {entityDetails && entityDetails.length > 0
            ? entityDetails.map(i => {
              return (
                <div className={style.allcard3}>
                  <Diet type={props.type} entityDetails={i} quantity={i.Counter > 0 ? i.Counter : null} />
                </div>
              );
            })
            : ""}
          {NotFound == true ? <>

            <div className={style.SectionContainer}>
              <div className={style.allcard}>
                <div className={style.card} >
                  <img className={style.SquareBaskte} src={`${config.basePath}/assest/SquareBackground.png`} ></img>
                  <div className={style.FlexColumn + " " + style.Postitionabsolute + " " + style.gapbasket}>
                    <img className={style.NoItem} src={config.basePath + "/assest/noItem.svg"} />
                    <div className={style.hLine6 + " " + style.Blod + " " + style.paddingzero}>{t("AddItem")}</div>
                    <div className={style.textaboutdoctor3 + " " + style.paddingzero + " " + style.GreyColor
                      + " " + style.widthDes + " " + style.textaligncenter}>{t("Des-AddItem")}</div>
                    <Link href={constants.HakeemProducts} style={{ textDecoration: "none" }}>
                      <Customebtn2 loadingPosition="start">
                        {t("Start-Shopping")}
                      </Customebtn2>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </>
            : ""}


          {/* <Link href={constants.HakeemProducts } style={{ textDecoration: "none" }}>
        <Customebtn className={style.searchbtn}  loadingPosition="start">
        {t("Shopping")}
      </Customebtn>
      </Link> */}

        </div>
      </div>
    </div>
  )
}

export default MedicalCard
